import { Link } from 'react-router-dom'
import { Logo, LeafMark } from '../common/Logo'
import { Button } from '../common/Button'
import { Icon } from '../common/Icon'
import { Reveal } from '../animation/Reveal'
import { WaveDivider } from '../common/WaveDivider'
import { footerNav } from '../../data/navigation'
import { company } from '../../data/company'

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="relative mt-24 text-white">
      <WaveDivider fill="#06231A" variant="curve" className="text-night" />
      <div className="grain relative bg-night" style={{ ['--leaf-vein' as string]: '#06231A' }}>
        {/* CTA band */}
        <div className="container-x border-b border-white/10 py-16">
          <Reveal className="grid items-center gap-8 md:grid-cols-[1.4fr_1fr]">
            <div>
              <h2 className="max-w-xl font-display text-h2 font-semibold text-white">
                Let’s grow stronger crops, the natural way.
              </h2>
              <p className="mt-3 max-w-lg text-white/70">
                Talk to our team about the right products for your crop, or about becoming a GreenbayBio
                retailer or distributor.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 md:justify-end">
              <Button to="/contact" variant="primary" size="lg">
                Enquire now <Icon name="ArrowRight" className="h-5 w-5" />
              </Button>
              <Button to="/catalog" variant="ghost-light" size="lg">
                Browse products
              </Button>
            </div>
          </Reveal>
        </div>

        {/* main */}
        <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[1.3fr_repeat(5,1fr)]">
          <div className="max-w-xs">
            <Logo tone="light" />
            <p className="mt-4 text-sm leading-relaxed text-white/60">{company.tagline}.</p>
            <address className="mt-5 space-y-2 text-sm not-italic text-white/70">
              <a href={`tel:${company.phoneHref}`} className="flex items-center gap-2 hover:text-white">
                <Icon name="Phone" className="h-4 w-4 shrink-0" /> {company.phoneDisplay}
              </a>
              <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-white">
                <Icon name="Mail" className="h-4 w-4 shrink-0" /> {company.email}
              </a>
              <p className="flex items-start gap-2">
                <Icon name="MapPin" className="mt-0.5 h-4 w-4 shrink-0" /> {company.address.full}
              </p>
            </address>
          </div>

          {footerNav.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-eyebrow font-semibold uppercase tracking-[0.18em] text-white/50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-white/70 transition-colors hover:text-lime">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        {/* bottom */}
        <div className="border-t border-white/10">
          <div className="container-x flex flex-col items-center justify-between gap-4 py-6 text-xs text-white/50 md:flex-row">
            <p>
              © {year} {company.legalName}. All rights reserved.
            </p>
            <p className="flex items-center gap-2">
              <LeafMark className="h-4 w-4 text-brand-400" />
              {company.tagline}
            </p>
          </div>
          <div className="container-x pb-6 text-center text-xs text-white/40">
            Developed and Maintained by{' '}
            <a
              href="https://www.fibermax.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-white/70 transition-colors hover:text-lime"
            >
              Fibermax Services Pvt Ltd
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
